import { queueMicroTask as r } from "./highrise1847.mjs";
var u = function(e) {
  r(function() {
    requestAnimationFrame(e);
  });
};
export {
  u as queueResizeObserver
};
